import {useApolloClient, type DataProxy, type OperationVariables} from '@apollo/client';

function useCacheReadQuery<QueryResult = any, QueryVariables = OperationVariables>(options : DataProxy.Query<QueryVariables, QueryResult>, optimistic ?: boolean) : QueryResult | null {
  const client = useApolloClient();
  const queryResult = client.readQuery(options, optimistic);
  return queryResult;
}

export default useCacheReadQuery;